export enum ObjectsEnum {
    PROJECTS = "projects",
    TASKS = "tasks",
    CLIENTS = "clients",
    COMPANIES = "companies",
    SELLING = "selling",
    EXPENSE = "expense",
    INCOME = "income",
}

export const basketItems = [
    { id: "projects", value: "Проєкти" },
    { id: "clients", value: "Клієнти" },
    { id: "companies", value: "Компанії" },
]